<template>
  <v-sheet
    color="white"
    elevation="5"
    rounded
    v-bind:style="`td { margin: 5px; }`" 
  >
      <v-dialog v-model="showDeleteConfirmationDialog" max-width="550px">
        <v-card>
          <v-card-title>
            <h3>Are you sure you want to delete show result?</h3>
          </v-card-title>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="showDeleteConfirmationDialog = false">
                Cancel
              </v-btn>
              <v-btn color="primary" @click="confirmDelete">
                 Delete
              </v-btn>
             <v-spacer />
           </v-card-actions>
        </v-card>
      </v-dialog>

      <v-alert v-if="!!errorMessage" type="error">
        {{ errorMessage }}
      </v-alert>  
      
      <table class="pl-5 pr-7">
        <tr>
            <th>Dog ID</th>
            <th>Date</th>
            <th>Category</th>
            <th>Judge</th>
            <th>Handler</th>
            <th>HIT</th>
            <th>Score</th>
            <th></th> <!-- actions column -->
        </tr>
        <tr :id="`#sr-empty`" v-if="!!emptyRow" class="orange lighten-4">
                  <td class="pr-1" :style="`text-align: left;`">
                    <v-text-field
                        id="srEmptyDogId"
                        ref="srEmptyDogId"
                        v-model="emptyRow.dogId"
                      />
                  </td>
                  <td class="pr-1 pl-1">             
                    <DatepickerFormatted 
                      :disableClearable="true"
                      :date="emptyRow.showDate"
                      v-on:updateDates="($event) => updateDates($event, 'showDate', emptyRow)" />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-autocomplete
                      v-model="emptyRow.categoryId"
                      item-value="id"
                      item-text="displayValue"
                      :items="showInfo.categories"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-autocomplete
                      v-model="emptyRow.judgeId"
                      item-value="id"
                      item-text="displayValue"
                      :items="showInfo.judges"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-text-field
                      v-model="emptyRow.dogHandler"
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-simple-checkbox
                      v-model="emptyRow.hit"                
                      v-ripple
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-autocomplete
                      v-model="emptyRow.score"
                      :items="[5,10]"
                    />
                  </td>
                  <td class="pl-1" style="width: 60px">
                    <v-icon class="mr-1" color="primary" @click="saveShowResult(emptyRow, showResults.length - 1)">
                      mdi-content-save-edit
                    </v-icon>
                  </td>
                </tr>
        </table>
        <v-divider inset />
        <v-divider inset />
        <v-virtual-scroll
          :items="showResults"
          :item-height="100"
          height="680"
          content-tag="table"
          id="AgilityShowResultsScroller"
          >
          <template v-slot:default="{ item, index }">
            <v-list-item key="item.resultId" :id="`sr-${item.resultId}`">
              <v-list-item-content>
                <tr :class="row_classes(item, index)" :id="`#sr-${item.resultId}`">
                  <td class="pr-1">
                    <v-text-field
                        v-model="item.dogId"
                      />
                        <v-tooltip bottom v-if="item.dogName">
                            <template v-slot:activator="{ on, attrs }">
                                <span class="text--secondary caption d-inline-block  text-truncate" style="width: 175px;"
                                    v-bind="attrs"
                                    v-on="on">
                                    <a tabindex="-1" :href="`/admin/dogs/${encodeURIComponent(item.dogId)}`" target="_blank" v-if="item.dogId">{{item.dogName}}</a>
                                </span>
                            </template>
                            <span>{{item.dogName}}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                            <template v-slot:activator="{ on, attrs }">
                                <span  class="text--secondary  caption d-inline-block  text-truncate" style="width: 175px;"
                                    v-bind="attrs"
                                    v-on="on">
                                    <a tabindex="-1" :href="`/admin/dogs/${encodeURIComponent(item.dogId)}`" target="_blank" v-if="item.dogId">{{item.dogName}}</a>
                                </span>
                            </template>
                            <span>{{item.dogName}}</span>
                        </v-tooltip>
                  </td>
                  <td class="pr-1 pl-1">             
                    <DatepickerFormatted 
                      :disableClearable="true"
                      :date="item.showDate"
                      v-on:updateDates="($event) => updateDates($event, 'showDate', item)" />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-autocomplete
                      v-model="item.categoryId"
                      item-value="id"
                      item-text="displayValue"
                      :items="showInfo.categories"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-autocomplete
                      v-model="item.judgeId"
                      item-value="id"
                      item-text="displayValue"
                      :items="showInfo.judges"
                      :rules="[(v) => !!v || 'Required']"
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-text-field
                      v-model="item.dogHandler"
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-simple-checkbox
                      v-model="item.hit"                
                      v-ripple
                    />
                  </td>
                  <td class="pr-1 pl-1">
                    <v-autocomplete
                      v-model="item.score"
                      :items="[5,10]"
                    />
                  </td>
                  <td class="pl-1" style="width: 60px">
                    <v-icon class="mr-1" color="primary" @click="saveShowResult(item, index)">
                      mdi-content-save-edit
                    </v-icon>
                    <v-icon :disabled="!item.resultId" tabindex="-1" @click="deleteShowResult(item)">
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
    
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import * as _ from "lodash";
import DatepickerFormatted from "../../../common/inputs/DatepickerFormatted.vue";
import showService from "@/services/admin/showService";

export default Vue.extend({
  name: "AgilityShowResultsEntry",
  components: {
    DatepickerFormatted
  },
  data: function() {
    return {
      showDeleteConfirmationDialog: false,
      deletedShowResultId: null,
      showResults: [] as any[],
      persistedShowResults: [] as any[],
      errorMessage: null as any,
      emptyRow: null as any,
    };
  },
  methods: {    
    emptyShowResultRow: function(lastPersistedRow: any, showResults: any[]){
      if(!lastPersistedRow){
        if(!!showResults && showResults.length > 0){
          lastPersistedRow = Object.assign({}, showResults[showResults.length - 1]);
        }
      }

      if(!!lastPersistedRow){
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: lastPersistedRow.showDate,
          judgeId: lastPersistedRow.judgeId,
          categoryId: lastPersistedRow.categoryId,
          hit: null,
          score: lastPersistedRow.score,
          showId: this.showId,
          transferred: null,
          transferredScore: null
        };
      } else {
        return {
          resultId: null,
          isNewRow: true,
          dogId: null,
          showDate: this.showInfo.defaultDate,
          judgeId: (!!this.showInfo.judges && this.showInfo.judges.length == 1) ? this.showInfo.judges[0].id : null,
          hit: null,
          score: 10,
          showId: this.showId,
          transferred: null,
          transferredScore: null
        };
      }
    },  
    reloadData: function() {
      if (this.showId) {
        this.$store.dispatch("changeLoaderStatus",true);

        showService
            .getShowResultsByShowId(this.showId, 'A')
            .then((res) => {
                this.showResults = _.cloneDeep(res);
                this.persistedShowResults = _.cloneDeep(res);
                this.emptyRow = Object.assign({}, this.emptyShowResultRow(null, res));
            })
            .catch(this.$handleError)
            .finally(() => { 
                this.$store.dispatch("changeLoaderStatus",false);
            }); 
      }
    }, 
    row_classes: function(item: any, index: number){
      if (!!item.resultId)
      {
        const index = this.showResults.findIndex(i => i.resultId === item.resultId);
        if(_.isEqual(this.showResults[index], this.persistedShowResults[index])){
          return '';
        }
      } 
      return 'orange  lighten-4';
    },
    saveShowResult: function(item: any, index: any) {
      this.$store.dispatch("changeLoaderStatus",true);
      const isAddingNewRow = !item.resultId;
      showService.updateShowResult(this.showId, 'A', item)
        .then((res) => {
          if(!res.success){
            this.errorMessage = res.messages.join(", ");
            if(isAddingNewRow){
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            }
          } else {
            if(isAddingNewRow){
              this.emptyRow.resultId = res.id;
              this.emptyRow.dogName = res.dogName;
              this.emptyRow.dogCallName = res.dogCallName;
              this.showResults.unshift(this.emptyRow);
              this.persistedShowResults = _.cloneDeep(this.showResults);

              this.emptyRow = Object.assign({}, this.emptyShowResultRow(this.emptyRow, this.showResults));
              const input = document.querySelector('#srEmptyDogId') as HTMLElement | null;

              if (input != null) {
                  input.focus();
              }
            } else {
              //in case the dogId value has been changed we need to update the dog name to allow admin to validate data entry
              this.showResults[index].dogName = res.dogName;
              this.showResults[index].dogCallName = res.dogCallName;
              this.persistedShowResults = _.cloneDeep(this.showResults);
            }
            this.errorMessage = null;
          }
        })
        .catch((e) => {
          this.errorMessage = "Changes couldn't be saved. Ensure there are no validation errors before retrying.";
        })
        .finally(() => { this.$store.dispatch("changeLoaderStatus",false);}); 
    },
    deleteShowResult: function(item: any) {
      if(item.resultId) {//if that item has been persisted already
        this.deletedShowResultId = item.resultId;
        this.showDeleteConfirmationDialog = true;
      } else {
        const index = this.showResults.indexOf(item);
        this.showResults.splice(index, 1);
      }
    },
    confirmDelete: function() {
      showService.deleteShowResult(this.showId, this.deletedShowResultId)
      .then((res) => {
        if(!res.success){
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.showResults[index].errors = res.messages.join(", ");
          this.deletedShowResultId = null;
        } else {
          const index = this.showResults.map(sr => sr.resultId).indexOf(this.deletedShowResultId);
          this.showResults.splice(index, 1);
          this.persistedShowResults.splice(index, 1);
        }   
      })
      .finally(() => {this.showDeleteConfirmationDialog = false});
    },
    updateDates: function (val: any, key: string, item: any) {
      item[key] = val?.date;
      //workaround to force rerendering after setting up formatted date
      this.$set(this, 'showResults', this.showResults);
    },
  },    
  created: function() {
    this.reloadData();
  },
  watch: {
    showId: function(newVal: String, oldVal: String) {
      if(newVal && newVal != oldVal){
        this.reloadData();
      }
    },
  },
  props: {
    showId: { type: String },
    showInfo: {type: Object}
  },
});
</script>
